import { createFileRoute } from "@tanstack/react-router";
import GraphqlExplorerPage from "@/pages/GraphqlExplorerPage";

export const Route = createFileRoute("/tools/graphql-explorer")({
  component: GraphqlExplorerPage,
});
